import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function P1StandeeDetails({ navigation, primaryDetails, setPrimaryDetails }) {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
    // Clear error for this field when user starts typing/selecting
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const validate = () => {
    const newErrors = {
      standee_location: !primaryDetails.standee_location,
      standee_brand: !primaryDetails.standee_brand,
      standee_count: !primaryDetails.standee_count,
    };

    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);

    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validate()) {
      navigation.go('p1-door-hanger-merchandising');
    }
  };

  const handleBack = () => {
    navigation.previous();
  };



  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">P1 STANDEE DETAILS</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">

              <Form>

                {/* P1 standee location */}
                <Form.Group className={`mb-4 ${errors.standee_location ? 'form-group-error' : ''}`}>
                  <Form.Label className="form-label">
                    P1 standee location <span className="form-required">*</span>
                  </Form.Label>
                  <div className="form-radio-group">
                    <div className={`form-radio-item${primaryDetails.standee_location === 'beside cashier' ? " selected" : ""}`}>
                      <div className="form-radio-flex">
                        <Form.Check
                          type="radio"
                          name="standee_location"
                          value="beside cashier"
                          label="beside cashier"
                          onChange={handleChange}
                          checked={primaryDetails.standee_location === 'beside cashier'}
                          className="form-radio"
                        />
                      </div>
                    </div>
                    <div className={`form-radio-item${primaryDetails.standee_location === 'others' ? " selected" : ""}`}>
                      <div className="form-radio-flex">
                        <Form.Check
                          type="radio"
                          name="standee_location"
                          value="others"
                          label="others"
                          onChange={handleChange}
                          checked={primaryDetails.standee_location === 'others'}
                          className="form-radio"
                        />
                      </div>
                    </div>
                  </div>
                  {errors.standee_location && (
                    <div className="form-error">
                      Required
                    </div>
                  )}
                </Form.Group>

                {/* P1 standee branding */}
                <Form.Group className={`mb-4 ${errors.standee_brand ? 'form-group-error' : ''}`}>
                  <Form.Label className="form-label">
                    P1 standee branding <span className="form-required">*</span>
                  </Form.Label>
                  <div className="form-radio-group">
                    {[
                      "3",
                      "2",
                      "1.5",
                      "old design - green bird",
                      "custom"
                    ].map((branding, index) => (
                      <div
                        key={`standee-brand-${index}-${branding}`}
                        className={`form-radio-item${primaryDetails.standee_brand === branding ? " selected" : ""}`}
                      >
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            name="standee_brand"
                            value={branding}
                            label={branding}
                            onChange={handleChange}
                            checked={primaryDetails.standee_brand === branding}
                            className="form-radio"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  {errors.standee_brand && (
                    <div className="form-error">
                      Required
                    </div>
                  )}
                </Form.Group>

                {/* P1 standee count */}
                <Form.Group className={`mb-4 ${errors.standee_count ? 'form-group-error' : ''}`}>
                  <Form.Label className="form-label">
                    P1 standee count <span className="form-required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="standee_count"
                    value={primaryDetails.standee_count || ''}
                    onChange={handleChange}
                    placeholder="Short answer text"
                    className={`form-input ${errors.standee_count ? 'form-input-error' : ''}`}
                  />
                  {errors.standee_count && (
                    <div className="form-error">
                      Required
                    </div>
                  )}
                </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                     Next →
                  </AppButton>
                </div>
              </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default P1StandeeDetails;